import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { ActivityClassificationService } from '../../services/activity-classification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-update-activity-classification',
  templateUrl: './update-activity-classification.component.html',
  styleUrls: ['./update-activity-classification.component.css']
})
export class UpdateActivityClassificationComponent implements OnInit {

  id: string;

  activityClassForm: FormGroup;
  classification: any;

  sub: Subscription;

  constructor(
    private activityClassificationService: ActivityClassificationService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router
  ) { 
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.sub = this.activityClassificationService.getActivityClassification(this.id).subscribe(activityClass => {
      this.classification = activityClass;
      this.activityClassForm.get('name').patchValue(activityClass.name);
      this.activityClassForm.get('description').patchValue(activityClass.description);
      this.activityClassForm.get('perSection').patchValue(activityClass.perSection);
      this.sub.unsubscribe();
    });
  }

  ngOnInit() {
    this.activityClassForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      perSection: ['']
    });
  }
  onSubmit() {
    this.classification = this.saveClassification();
    this.activityClassificationService.putActivityClassification(this.classification, this.id);
    this.router.navigate(['/activity_class']);
  }
  saveClassification() {
		const currentDate = new Date();

		const classificationJson = {
			active: 1,
			createdAt: currentDate,
			name: this.activityClassForm.get('name').value,
			description: this.activityClassForm.get('description').value,
			perSection: this.activityClassForm.get('perSection').value,
			updatedAt: currentDate
		};

		return classificationJson;
	}

}
